import React from 'react';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  facilityName?: string;
  locationName?: string;
}

const SensorExtraInfo: React.FC<IProps> = ({ facilityName, locationName }) => {
  const { t } = useTranslation();

  return (
    <div className={style.extraInfoWrapper}>
      {t('Location')}{' '}
      <span className={style.extraInfo}>{`${facilityName || '-'} / ${locationName || '-'}`}</span>
    </div>
  );
};

export default SensorExtraInfo;
